import { getMainDefinition } from '@apollo/client/utilities'

import { createWsLink } from 'Services/Apollo/Links/RequestLink/createWsLink'
import Shared from 'Services/Shared'

function isSubscription({ query }: any): boolean {
  const def = getMainDefinition(query)
  return def.kind === 'OperationDefinition' && def.operation === 'subscription'
}

function restartWsClient(kind: 'main' | 'chat') {
  if (kind === 'main') {
    const url = Shared.getMainSubscriptionUrl()
    if (!url) return

    Shared.getMainSubscriptionClient()?.dispose()
    createWsLink({ url })
  }

  if (kind === 'chat') {
    const url = Shared.getChatSubscriptionUrl()
    if (!url) return

    Shared.getChatSubscriptionClient()?.dispose()
    createWsLink({ url })
  }
}

export default { isSubscription, restartWsClient }
